import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ITokenType } from "../../types/tokenType";

export interface IUserObject {
  email: string;
  first_name: string;
  last_name: string;
  defaultRole: string;
  loggedInDate?: string;
  loggedInTime?: string;
  iat?: number;
  exp?: number;
}
export interface InitialState {
  token: ITokenType;
  lastAPITriggerTime: number;
  userObj: IUserObject;
  permissions: any;
  codelistDetails: any;
  connetorDetails: any;
}

const initialState: InitialState = {
  token: {
    accessToken: "",
    refreshToken: "",
  },
  lastAPITriggerTime: new Date().getTime(),
  userObj: {
    email: "",
    first_name: "",
    last_name: "",
    defaultRole: "",
    loggedInDate: "",
    loggedInTime: "",
  },
  permissions: [],
  codelistDetails: {},
  connetorDetails: {},
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setToken: (state: any, action: PayloadAction<ITokenType>) => {
      state.token = action.payload;
    },
    setLastAPITriggerTime: (state: any, action: PayloadAction<number>) => {
      state.lastAPITriggerTime = action.payload;
    },
    setLogOut: (state: any) => {
      state.token = {
        accessToken: "",
        refreshToken: "",
      };
    },
    setUserObj: (state: any, action: PayloadAction<IUserObject>) => {
      state.userObj = action.payload;
    },
    setUserPermissions: (state: any, action: any) => {
      state.permissions = action.payload;
    },
    setCodelistDetails: (state: any, action: any) => {
      state.codelistDetails = action.payload;
    },
    setConnectorDetails: (state: any, action: any) => {
      state.connetorDetails = action.payload;
    },
  },
});

export const {
  setToken,
  setLastAPITriggerTime,
  setLogOut,
  setUserObj,
  setUserPermissions,
  setCodelistDetails,
  setConnectorDetails,
} = commonSlice.actions;
